import React from 'react'
import styled from 'react-emotion'

const TwoColSection = styled.div(props => `
  display: flex;
  flex-direction: column;
  background-color: ${props.bgColor || ''};
  overflow: hidden;

  &:before,:after {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }
  
  @media (min-width: 1023px) {
    flex-direction: row;
	}
`)


const Left = styled.div(props => `
  float: left;
  background-color: ${props.bgColor || '#fcc71b'};
  color: ${props.color || 'inherit'};
  position: relative;
  padding: ${props.image ? '0': '2rem 1rem'};
  transform: translateY(${props.skew ? '-10%' : '0'});

  ${props.skew ? 'z-index: 10;' : ''}

  ${props.image ? `
    img {
      width: 100%;
    }
  ` : `
    display: flex;
    align-items: center;
  `}

  @media (min-width: 1023px) {
    transform: translateY(0%);
    transform: translateX(${props.skew ? '0%' : '0'});
    width: ${props.skew ? '45%' : '55%'};

    ${props.image ? '': `
      padding: 3rem 5rem;
      padding-right: 2rem;
    `}
    ${props.image ? '': `
      padding: 3rem 5rem;
      padding-right: 2rem;
    `} 
	}
`)

const Right = styled.div(props =>`
  float: left;
  background-color: ${props.bgColor || '#fff'};
  color: ${props.color || 'inherit'};
  padding: ${props.image ? '0': '2rem 1rem'};
  transform: translateY(${props.skew ? '10%' : '0'});
  ${props.skew ? 'z-index: 10;' : ''}
  min-height: 300px;

  ${props.image ? `
    img {
      width: 100%;
    }
  ` : `
    display: flex;
    align-items: center;
  `}

  @media (min-width: 1023px) {
    transform: translateY(0%);
    transform: translateX(${props.skew ? '0%' : '0'});
    width: ${props.skew ? '45%' : '55%'};
    ${props.image ? '': `
      padding: 3rem 5rem;
      padding-left: 1rem;
    `} 
    ${props.image ? '': `
      padding: 3rem 5rem;
      padding-left: 1rem;
    `} 
	}
`)

const SkewLeft = styled.div(props => `
  background-color: ${props.bgColor || '#fcc71b'};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0px;
  z-index: 1;
  transform-origin: right bottom;
  transform: skewY(-8deg);
  padding: 1rem;
  
  @media (min-width: 1023px) {
    transform: skew(-13deg);
    padding: 0;
  }
`)

const SkewRight = styled.div(props => `
  background-color: ${props.bgColor || '#fff'};
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0px;
  z-index: 1;
  transform-origin: right bottom;
  transform: skewY(8deg);
  padding: 1rem;

  @media (min-width: 1023px) {
    transform: skew(13deg);
    padding: 0;
  }
`)

const ContentLeft = styled.div(props => `
  position: relative;
  z-index: 10;
  transform: translateY(${props.skew ? '12%' : '0'});

  ${props.bgImgSrc ? `
    background-image: url(${props.bgImgSrc});
    background-size: cover;
    background-repeat: no-repeat;
    height: 100%;
    margin-left: -6rem;
    min-height: 500px;
    margin-bottom: 0rem;
  ` : ''}

  @media (min-width: 1023px) {
    transform: translateY(0%);
    transform: translateX(${props.skew || props.image ? '0' : '0'});
  }
`)

const ContentRight = styled.div(props => `
  position: relative;
  z-index: 10;
  transform: translateY(0);
  margin: 0 auto;

  ${props.bgImgSrc ? `
    background-image: url(${props.bgImgSrc});
    background-size: cover;
    background-repeat: no-repeat;
    height: 100%;
    margin-left: -6rem;
    min-height: 500px;
    margin-bottom: 0rem;
  ` : ''}

  @media (min-width: 1023px) {
    transform: translateY(0%);
    transform: translateX(0);
    margin-bottom: 0rem;
  }
`)

export const LeftCol = (props) => {
  return (
    <Left {...props}>
      <ContentLeft  {...props}>
        {props.children}
      </ContentLeft>
      {props.skew ? (
        <SkewLeft bgColor={props.bgColor}/>
      ) : (null)}
    </Left>
  );
}

export const RightCol = (props) => {
  return (
    <Right {...props}>
      <ContentRight  {...props}>
        {props.children}
      </ContentRight>
      {props.skew ? (
        <SkewRight bgColor={props.bgColor}/>
      ) : (null)}
    </Right>
  );
}

export const TwoCol = (props) => {
  return (
    <TwoColSection {...props}>
      {props.children}
    </TwoColSection>
  )
}



// WEBPACK FOOTER //
// ./src/components/two-col.js